import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ManageTourListBzp'],
});

export const manageTourListBzpApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findSearchDatatableBzpByPagination: builder.query({
      query: (payload) => {
        let url = `manage-tour-list/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            const k = key === "status" ? "status_bzp": key
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [k, v]));
            } else {
              params.push([k, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourListBzp'],
    }),

    findDataInitBzp: builder.query({
      query: () => `manage-tour-list-bzp-init/`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourListBzp'],
    }),
    findStatusTotalRecordBzp: builder.query({
      query: (bzp) => `manage-tour-list/bzp-summary/?bzp=${bzp}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourListBzp'],
    }),
    findDataTableBzpPagination: builder.query({
      query: (payload) => {
        let url = `dn_list/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSe

        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourListBzp'],
    }),
    updateManageTourBzp: builder.mutation({
      query: (payload) => ({
        url: `manage-tour-list/${payload.id}/`,
        method: 'PATCH',
        body: payload,
      }),
    }),
    submitManageTourBzp: builder.mutation({
      query: (payload) => ({
        url: `manage-tour-list/bzp-submit/`,
        method: 'POST',
        body: payload,
      }),
    }),
//     findDownloadCSVManageTourBzpList: builder.mutation({
//       query: (payload) => {
//         let url = `manage-tour-list/`;
//         const params = [];
//         // loop over payload entries, and expand any arrays into params array
//         Object.entries(payload).forEach(([key, value]) => {
//           if (value != null) {
//             if (Array.isArray(value)) {
//               params.push(...value.map((v) => [key, v]));
//             } else {
//               params.push([key, value]);
//             }
//           }
//         });

//         // construct query params using URLSearchParams
//         const searchParams = new URLSearchParams(params);

//         return { url: `${url}?${searchParams.toString()}` };
//       },
//       responseHandler: async (response) =>
//         window.location.assign(
//           window.URL.createObjectURL(await response.blob())
//         ),
//       cache: 'no-cache',
//       keepUnusedDataFor: 0,
//       providesTags: ['CallingSheet'],
//     }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSubmitManageTourBzpMutation,
  useFindDataInitBzpQuery,
  useFindStatusTotalRecordBzpQuery,
  useUpdateManageTourBzpMutation,
  // useFindDownloadCSVManageTourListBzpMutation,
} = manageTourListBzpApi;
